var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgType = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M21 5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2a4 4 0 0 0 4 4h2a2 2 0 0 0 2-2zM5 3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2a4 4 0 0 0 4-4V5a2 2 0 0 0-2-2zm16 16a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2a4 4 0 0 1 4-4h2a2 2 0 0 1 2 2zM3 19a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4H5a2 2 0 0 0-2 2z",
  clipRule: "evenodd"
})));
export default SvgType;